export { VuesaxLinearArrowCircleRight4 } from "./VuesaxLinearArrowCircleRight4";
